module.exports = __webpack_public_path__ + "static/card7-d76ac2c8995f44f1d570389218145fae.png";